import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Dialog, DialogBody } from '../../common/components/Modal/Modal';
import { ScanPlatform } from '../../organization/scans/enums/ScanPlatform';
import { ScansService } from '../../organization/scans/services/ScansService';
import { CreateScanForm } from '../components/CreateScanForm';
import { UrlHelper } from '../../common/utils/UrlHelper';
import { EXTERNAL_URLS } from '../../routing/routes';
import { DocsAlert } from '../../common/docs/DocsAlert';

type Props = {
  onClosed: (scanId: number | undefined) => void;
};

export const CreateScanFlow = ({ onClosed }: Props) => {
  const [scanService] = useState(new ScansService());

  useEffect(() => {
    return () => scanService.cancelAllRequests();
  }, [scanService]);

  const handleSubmit = async (
    name: string,
    projectId: number,
    profileId: number | null,
    platform: ScanPlatform,
    hostname: string | null,
    lastSeenHours: number | null,
    workLoad: number | null,
    maxFilesPerSecond: number | null,
    maxFileSize: number | null,
    exclude: string[],
    tags: string[]
  ) => {
    const scanId = await scanService.createCrowdStrikeScan({
      name,
      projectId,
      profileId,
      platform,
      hostname,
      lastSeenHours,
      workLoad,
      maxFilesPerSecond,
      maxFileSize,
      exclude,
      tags,
    });

    onClosed(scanId);
  };

  return (
    <Dialog
      title={t('startNewScan')}
      subtitle={<DocsAlert helpText="startNewScanHelp" href={UrlHelper.wrapExternalDocsUrl(EXTERNAL_URLS.DOCS_SCANS_CROWDSTRIKE_PARAMS)} />}
      onDismiss={() => onClosed(undefined)}
      maxWidth={'lg'}
    >
      <DialogBody>
        <CreateScanForm
          submit={{ label: t('createScanForm.submit'), action: handleSubmit }}
          back={{ label: t('createScanForm.back'), action: () => onClosed(undefined) }}
        />
      </DialogBody>
    </Dialog>
  );
};
